export class CreateResponse {
    uuid?: string
}